export const DELETE_CONFIRMATION_TEXT = 'delete';